import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import JoinRoom from './components/JoinRoom';
import HostInterface from './components/HostInterface';
import GamePlay from './components/GamePlay';
import CreateRoom from './components/CreateRoom';
import React from 'react';
import * as Sentry from '@sentry/react';

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={<div className="flex items-center justify-center h-screen text-red-600">An error occurred. Please refresh the page.</div>}
      onError={(error) => {
        if (import.meta.env.MODE !== 'production') {
          console.error('ErrorBoundary caught an error:', error);
        }
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/create" element={<CreateRoom />} />
          <Route path="/join" element={<JoinRoom />} />
          <Route path="/host/:roomCode" element={<HostInterface />} />
          <Route path="/game/:roomCode" element={<GamePlay />} />
        </Routes>
      </Router>
    </Sentry.ErrorBoundary>
  );
}

export default App;
